/* eslint-disable import/no-anonymous-default-export */

// import config
import { storylinerRootDomain } from '../../../../config';

// blog
export default {
  hero: {
    title: 'Dein <span class="has-marker">kreatives</span> Upgrade',
    intro: 'Wir analysieren, recherchieren und gestalten die Zukunft der Inhaltskreation.',
  },
  nextPage: {
    href: '/blog/seite/2',
    label: 'Nächste Seite',
  },
  seo: {
    description:
      'Wir analysieren, recherchieren und gestalten die Zukunft der Inhaltskreation. Lese den Storyliner Blog…',
    image: `${storylinerRootDomain}/img/screensavers/screensaver-break-creative-barriers-storyliner.jpg`,
    title: 'Blog - Storyliner',
  },
};
